/**
 * Decides whether the internal free-bet / inventory debug panel is visible.
 *
 * - Never in production.
 * - Local dev (`NODE_ENV === 'development'`) → on by default, regardless of
 *   `NEXT_PUBLIC_ENV` (which is set to `staging` in `.env.local`).
 * - Deployed staging / preview → per-user opt-in via `?fbdebug=1` ONLY.
 *
 * We intentionally do NOT auto-enable from a shared env var on deployed
 * environments: a shared staging env var (NEXT_PUBLIC_STORE_DEBUG=true) showed
 * the panel to CLIENTS testing on staging, which is confusing since debug items
 * can't actually be used to place a bet. A query param is per-session and safe.
 */
export function isInventoryDebugEnabled(params: {
  env: string | undefined
  nodeEnv: string | undefined
  fbdebugParam: string | null
}): boolean {
  const { env, nodeEnv, fbdebugParam } = params
  if (env === 'production') return false
  if (nodeEnv === 'development') return true
  return fbdebugParam === '1'
}
